import { useMemo } from 'react'
import compact from 'lodash/compact'
import { milesToMeters } from 'components/search/utils/distance'
import { getAlgoliaTimestamp } from 'lib/date-utils'

const maxDistanceMeters = Math.round(milesToMeters(6000))

export default function useSearchConfiguration(searchState) {
  return useMemo(() => buildConfiguration(searchState), [searchState])
}

function buildConfiguration({
  access,
  division,
  programStatus,
  radius,
  selection,
}) {
  const comparisonTimestamp = getAlgoliaTimestamp()

  const beginningOfLastYear = new Date(new Date().getFullYear() - 1, 0, 1)
  const beginningOfLastYearTimestamp = getAlgoliaTimestamp(beginningOfLastYear)

  const filters = compact([
    access && `restricted_access:${access}`,
    division && `division:${division}`,
    programStatus === 'open'
      ? `registration_close_ts > ${comparisonTimestamp}`
      : `registration_close_ts:${beginningOfLastYearTimestamp} TO ${comparisonTimestamp}`,
  ]).join(' AND ')

  return {
    filters,
    aroundRadius:
      radius === 'any' ? maxDistanceMeters : Math.round(milesToMeters(radius)),
    getRankingInfo: true,
    ...selection.toIndexSearchParams(),
  }
}
